import axios from "axios";

const { REACT_APP_VEHICLES_API } = process.env;

export const getVehicleTypes = async (customer) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_types`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const getVehicleType = async (customer, type) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "get",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_types/${type}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const addVehicleTypes = async (customer, data) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "post",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_types`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const updateVehicleTypes = async (customer, data, type) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "put",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_types/${type}`,
      headers: { Authorization: `Bearer ${token}` },
      data,
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};

export const deleteVehicleTypes = async (customer, vehicleTypeName) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  try {
    const res = await axios({
      method: "delete",
      url: `${REACT_APP_VEHICLES_API}/${customer}/vehicle_types/${vehicleTypeName}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: res.data };
  } catch (e) {
    return { detail: e.response.data };
  }
};
